import _ from 'lodash';
import { FlightSearchTypes } from '../../constants';

const isFlightSegmentsValid = (flightSegments, flightSearchType) =>
  flightSegments &&
  flightSegments.length > 0 &&
  (flightSearchType === FlightSearchTypes.ROUND_TRIP ||
    flightSearchType === FlightSearchTypes.ONE_WAY ||
    flightSegments.length > 1) &&
  !_.find(
    _.take(
      flightSegments,
      flightSearchType === FlightSearchTypes.ROUND_TRIP ||
        flightSearchType === FlightSearchTypes.ONE_WAY
        ? 1
        : 5,
    ),
    (f) => !f.origin || !f.destination,
  );

export default isFlightSegmentsValid;
